/** Shopify CDN: Minification failed

Line 12:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 14:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 26:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 28:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 30:0 Transforming const to the configured target environment ("es5") is not supported yet

**/
(function () {
	document.addEventListener("shopify:section:load", function () {
		const slider = new Swiper(".js-media-list", getSliderSettings);

		const subSlider = new Swiper(
			".js-media-sublist",
			getSubSliderProductSettings
		);

		setTimeout(function () {
			slider.update();
			subSlider.update();
		}, 200);
	});
})();

let attached = false;

let imageContainer = document.querySelector("#image");

const followMouse = (event) => {
	imageContainer.style.left = event.pageX + "px";
	imageContainer.style.top = event.pageY + "px";
};

function showImage() {
	if (!attached) {
		attached = true;
		imageContainer.style.display = "block";
		document.addEventListener("pointermove", followMouse);
	}
}

function hideImage() {
	attached = false;
	imageContainer.style.display = "";
	document.removeEventListener("pointermove", followMouse);
}
